import React from "react";
import {Button} from "@mui/material";

export default function DHButtonDefault({ label, icon, disabled, onClick, style, active}) {

    return <Button variant="contained" disabled={disabled}
                   onClick={() => onClick()} startIcon={icon ? icon : undefined}
                   style={{textTransform: 'none', letterSpacing:"0.1em", backgroundColor: active !== null && active !== undefined && !active ? "gray" : "", ...style}}>{label}
    </Button>
}